import React from 'react';
import logHandledError from '../../helpers/log-handled-error';
const TrackInteractionContext = React.createContext({
    identify: (_params) => {
        logHandledError('Missing `TrackInteractionProvider`. Components that use `identify` need to be wrapped in a `TrackInteractionProvider`');
        return Promise.resolve();
    },
    trackEvent: (_params) => {
        logHandledError('Missing `TrackInteractionProvider`. Components that use `trackEvent` need to be wrapped in a `TrackInteractionProvider`');
        return Promise.resolve();
    },
});
export default TrackInteractionContext;
